export default __webpack_public_path__ + "static/media/question4-mobile.77ff3964.svg";